"use client";

import { useEffect, useState } from "react";

function SearchIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.198 14.6312L14.6324 15.1969L19.4344 20L20 19.4343L15.198 14.6312Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3991 16.8012C13.9332 16.8012 16.7982 13.9356 16.7982 10.4006C16.7982 6.86566 13.9332 4 10.3991 4C6.86496 4 4 6.86566 4 10.4006C4 13.9356 6.86496 16.8012 10.3991 16.8012Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

const placeholders = [
  "window function applications",
  "retail-related sql questions",
  "linear regression concepts",
];

function getRandomPlaceholder() {
  return placeholders[Math.floor(Math.random() * placeholders.length)] ?? placeholders[0]!;
}

type Props = {
  value: string;
  onChange: (query: string) => void;
  isLoading?: boolean;
};

export function QueryInput({ value, onChange, isLoading = false }: Props) {
  const [internalValue, setInternalValue] = useState(value);
  const [placeholder] = useState(getRandomPlaceholder);

  useEffect(() => setInternalValue(value), [value]);

  useEffect(() => {
    const timer = setTimeout(() => onChange(internalValue), 400);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [internalValue]);

  return (
    <div className="relative flex items-center">
      <div className="absolute left-[10px] text-iq-grey-medium flex items-center">
        {isLoading ? (
          <div className="w-[20px] h-[20px] border-2 border-iq-grey-medium border-t-transparent rounded-full animate-spin" />
        ) : (
          <SearchIcon />
        )}
      </div>
      <input
        autoFocus
        type="text"
        placeholder={placeholder}
        value={internalValue}
        onChange={(e) => setInternalValue(e.target.value)}
        className="w-full h-[40px] pl-[44px] pr-[10px] bg-white border border-iq-grey-light rounded-[var(--iq-border-radius-md)] text-iq-grey-dark focus:outline-none focus:border-iq-blue"
      />
    </div>
  );
}
